<template>
  <svg width="86" height="38" viewBox="0 0 86 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      class="icon-arrow"
      d="M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM84.7678 20.7678C85.7441 19.7915 85.7441 18.2085 84.7678
       17.2322L68.8579 1.32233C67.8816 0.34602 66.2986 0.34602 65.3223 1.32233C64.346 2.29864 64.346 3.88155 65.3223 4.85786L79.4645 19L65.3223
        33.1421C64.346 34.1184 64.346 35.7014 65.3223 36.6777C66.2986 37.654 67.8816 37.654 68.8579 36.6777L84.7678 20.7678ZM3 21.5H83V16.5H3V21.5Z"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconArrowRight'
  }
</script>
